<template>
  <div class="animated fadeIn">
    <div id="custom_backdrop"></div>
    <div class="row pageinfo">
      <b-col cols="4" lg="6">
        <!--Display Trash or Normal Table View-->
        <h2>Duplicate Hauls</h2>
       <!--  <h2 v-show="!trash">Hauls</h2>
       <h2 v-show="trash">Hauls - Trash</h2>-->
      </b-col>

      <!--Gear Icon :data            :data   = "items_csv"      @click="openExcel()"          = "items"   ref="excel"   v-b-popover.hover.top="'Export to csv'"   @click="openExcel()"         :data   = "items" -->
      <b-col cols="8" lg="6">
        <b-btn class="pull-right ml5" v-b-popover.hover.top="'Select Datapoints'" variant="info" @click="openSelectColumns()"><i class="fa fa-cog"></i></b-btn>
        <!--<b-btn class="pull-right ml5" v-b-popover.hover.top="'Activate/Deactivate bbl'" variant="info" @click="bbl()"><i class="fa fa-bullseye"></i></b-btn> -->
        <!--<download-excel
            ref="excel"
            :data   = "items_csv" 
            :fields = "json_fields"
            type    = "csv"
            :name   = "filename">   
            <span>
              <b-btn class="pull-right ml5" v-show="activated" v-b-popover.hover.top="'Export to csv'" variant="info"><i class="fa fa-file-excel-o"></i></b-btn>           
            </span>
        </download-excel>
        <b-btn class="pull-right ml5" v-b-popover.hover.top="'Create Folder'" variant="info" @click="openCreateFolder()"><i class="fa fa-folder"></i></b-btn>
        -->
        <!-- <b-btn v-if="role =='super_analyst' || role =='analyst' || role =='trucking_company_admin'" class="pull-right ml5" :pressed.sync="myToggle" v-b-popover.hover.top="'Activate/Deactivate hauls approved'" variant="info" @click="h_approved_change()"><i class="fa fa-toggle-on"></i></b-btn> --> 
      </b-col>

    </div>

    <!-- Filters block-->
    <div class="filters pb-2">
      <b-row>
        <b-col order="1" order-md="1" cols="8" sm="6" md="4" lg="2" class="my-1">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <b-form-input v-model="filter" placeholder="Search" />
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </div>
          </div>
        </b-col>
<!--
        <b-col order="3" order-md="2" v-if="role =='super_admin' || role =='trucking_company_admin'" sm="6" md="2" lg="2" class="my-1" title="Actived / Deleted">
          <b-dropdown class="custom_dropdown custom_dropdown_b" id="ddown1" :text="dpdt">
            <b-dropdown-item @click="trashHaul()">Active</b-dropdown-item>
            <b-dropdown-item @click="trashHaul()">Trash</b-dropdown-item>
          </b-dropdown>
        </b-col>
        <b-col order="5" order-md="4" sm="6"  md="2" lg="2" class="my-1" title="Folder">
          <b-dropdown class="custom_dropdown custom_dropdown_b" id="ddown1" :text="filters_save.folder">
            <b-dropdown-item @click="Folders('All Folders', 0)">All Folders</b-dropdown-item>
            <b-dropdown-item v-for="(folder) in folders" @click="Folders(folder.name, folder.id)">{{folder.name}}</b-dropdown-item>
            <b-dropdown-item @click="Folders('Unassigned Hauls', 0)">Unassigned Hauls</b-dropdown-item>
          </b-dropdown>
        </b-col>
        <b-col order="2" order-md="5" cols="4" sm="6" md="2" lg="2" class="ml-auto my-1">
          <b-button v-if="role =='super_admin' || role =='trucking_company_admin'" class="pull-right" variant="primary" @click="showNewHaulModal()">Add Haul</b-button>
        </b-col>-->
      </b-row> 

      <b-row>
        <b-col v-if="role =='super_admin' || role =='trucking_company_admin' || role =='trucking_operational_manager'" class="my-1" title="Energy Companies" sm="6" md="3" lg="2">
          <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="filters_save.energy_company_name" >
            <b-dropdown-item @click="ecFilter('All Energy Companies', 0)">All Energy Companies</b-dropdown-item>
            <b-dropdown-item v-for="energy_company_filter in energy_companies_filter" @click="ecFilter(energy_company_filter.company_name, energy_company_filter.id)">{{energy_company_filter.company_name}}</b-dropdown-item>
          </b-dropdown>
        </b-col>
       <b-col class="my-1 f2" title="Drivers" sm="6" md="3" lg="2">
          <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="filters_save.driver_name">
            <b-dropdown-item @click="dFilter('All Drivers', 0)">All Drivers</b-dropdown-item>
            <b-dropdown-item v-for="driver_filter in drivers_filter" @click="dFilter(driver_filter.username, driver_filter.id)">{{driver_filter.username}}</b-dropdown-item>
          </b-dropdown>
        </b-col> 
        <b-col v-if="role !=='trucking_company_admin' || role =='trucking_operational_manager'" class="my-1 f4" title="Trucking Companies" sm="6" md="3" lg="2">
            <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop" :text="filters_save.trucking_company_name">
              <b-dropdown-item @click="tcFilter('All Trucking Companies', 0)"><h6>All Trucking Companies</h6></b-dropdown-item>
              <b-dropdown-item v-for="trucking_company_filter in trucking_companies_filter" @click="tcFilter(trucking_company_filter.name, trucking_company_filter.id)">{{trucking_company_filter.name}}</b-dropdown-item>
            </b-dropdown>
        </b-col>
        <b-col class="my-1 f5" title="Trucks" sm="6" md="3" lg="2">
            <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop" :text="filters_save.truck_name">
              <b-dropdown-item @click="tFilter('All Trucks', 0)">All Trucks</b-dropdown-item>
              <b-dropdown-item v-for="truck_filter in trucks_filter" @click="tFilter(truck_filter.truck_name, truck_filter.id)">{{truck_filter.truck_name}}</b-dropdown-item>
            </b-dropdown>
        </b-col>
        <b-col class="my-1 f6" sm="6" md="3" lg="2">
          <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop" :text="filters_save.load_name" title="Load Locations">
            <b-dropdown-item @click="lFilter('All Loads', 0)">All Loads</b-dropdown-item>
            <b-dropdown-item v-for="load_location_filter in load_locations_filter" @click="lFilter(load_location_filter.legal_location, load_location_filter.id)">{{load_location_filter.legal_location}}</b-dropdown-item>
          </b-dropdown>
        </b-col>
        <b-col class="my-1 f7" sm="6" md="3" lg="2">
          <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="filters_save.unload_name" title="Unload Locations">
            <b-dropdown-item @click="uFilter('All Unloads', 0)">All Unloads</b-dropdown-item>
            <b-dropdown-item v-for="unload_location_filter in unload_locations_filter" @click="uFilter(unload_location_filter.legal_location, unload_location_filter.id)">{{unload_location_filter.legal_location}}</b-dropdown-item>
          </b-dropdown>
        </b-col>
       <!-- <b-col v-if="role =='super_admin' || role =='super_analyst' || role =='analyst' || role =='trucking_company_admin'" class="my-1" title="Fluid Types" sm="6" md="3" lg="2">
          <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="filters_save.fluid_type_name" >
            <b-dropdown-item @click="ftFilter('All Fluid Types', 0)">All Fluid Types</b-dropdown-item>
            <b-dropdown-item v-for="fluid_type_filter in fluid_types_filter" @click="ftFilter(fluid_type_filter.name, fluid_type_filter.id)">{{fluid_type_filter.name}}</b-dropdown-item>
          </b-dropdown>
        </b-col>
        <b-col class="my-1 f8" sm="6" md="3" lg="2">
          <b-dropdown class="custom_dropdown custom_dropdown_b" right @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="filters_save.flag_name" title="Flag">
            <b-dropdown-item @click="vFilter('All Flags',0)">All Flags</b-dropdown-item>
            <b-dropdown-item @click="vFilter('Volume > 60 m³',1)">Volume > 60 m³</b-dropdown-item>
            <b-dropdown-item @click="vFilter('BS&W - 100%',2)">BS&W - 100%</b-dropdown-item>
            <b-dropdown-item @click="vFilter('BS&W < 0.5%',3)">BS&W < 0.5%</b-dropdown-item>
            <b-dropdown-item @click="vFilter('BS&W - Additional Fees Apply',4)">BS&W - Additional Fees Apply</b-dropdown-item>
            <b-dropdown-item @click="vFilter('Haul without Nom',5)">Haul without Nom</b-dropdown-item>
            <b-dropdown-item @click="vFilter('With Contracts',6)">With Contracts</b-dropdown-item>
            <b-dropdown-item @click="vFilter('Without Contracts',7)">Without Contracts</b-dropdown-item>
            <b-dropdown-item @click="vFilter('Rerouted: Yes',8)">Rerouted: Yes</b-dropdown-item>
            <b-dropdown-item @click="vFilter('Rerouted: No',9)">Rerouted: No</b-dropdown-item>
            <b-dropdown-item @click="vFilter('Haul Duplicated',10)">Haul Duplicated</b-dropdown-item>
            <b-dropdown-item @click="vFilter('Drive Time:Neg',12)">Drive Time:Neg</b-dropdown-item>
            <b-dropdown-item v-if="role =='trucking_company_admin'" @click="vFilter('Unknow Load Location',0)">Unknow Load Location</b-dropdown-item>
            <b-dropdown-item v-if="role =='trucking_company_admin'" @click="vFilter('Price Anomaly',14)">Price Anomaly</b-dropdown-item>
            <b-dropdown-item v-if="role =='trucking_company_admin'" @click="vFilter('Duplicated Truck Ticket',15)">Duplicated Truck Ticket</b-dropdown-item>
            <b-dropdown-item v-if="role =='trucking_company_admin'" @click="vFilter('Drive Time Anomaly',16)">Drive Time Anomaly</b-dropdown-item>
          </b-dropdown>
        </b-col>
        <b-col v-if="role =='trucking_company_admin'" class="my-1 f8" sm="6" md="3" lg="2">
          <b-dropdown class="custom_dropdown custom_dropdown_b" right @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="Approved" title="Approved">
            <b-dropdown-item @click="approvedFilter('All')">All</b-dropdown-item>
            <b-dropdown-item @click="approvedFilter('Approved')">Approved</b-dropdown-item>
            <b-dropdown-item @click="approvedFilter('Unapproved')">Unapproved</b-dropdown-item>
          </b-dropdown>
        </b-col> -->
        <b-col class="my-1 f9" title="Initial Date" sm="6" md="4" lg="3">
          <b-form-input id="haul_start_datetime" v-model="filter_by.initial_date" @change="iFilter" type="date" ></b-form-input>
        </b-col>
        <b-col class="my-1 lg-3 f10" title="End date" sm="6" md="4" lg="3">
          <b-form-input id="haul_end_datetime" v-model="filter_by.end_date" @change="eFilter" type="date"></b-form-input>
        </b-col>       
        <b-col class="my-1 lg-3 f11 " style=" padding-top: 3px; padding-bottom: 3px;" sm="6" md="4" lg="3">
          <b-button block style="height: 100%;" @click="clearFilters()">Clear</b-button>
        </b-col> 
      </b-row>
<!--ml-auto
      <b-row>
        <b-col v-if="haul_ids.length > 0 && Approved==='Show Approved'" class="my-1">
          <div class="card bulk-action-controls m-0">
            <div class="card-body p-1 d-flex align-middle">
              <p class="col-sm-3 ml-2 px-0 my-auto align-middle"> {{haul_ids.length}} haul(s) selected of {{totalRows}}</p>
              <b-button v-if="!allSelected" class="col-sm-2 ml-0 btn-select" @click="selectAllHauls"> Select All </b-button>
              <b-dropdown id="ddown1" text="Bulk Actions" class="mx-2 my-auto align-middle" title="Bulk Actions">
                <b-dropdown-item v-if="!this.trash" @click="deleteHaul()">Delete</b-dropdown-item>
                <b-dropdown-item v-else  @click="restoreHauls()">Restore</b-dropdown-item>
                <b-dropdown-item v-if="filters_save.folder == 'All Folders' || filters_save.folder == 'Unassigned Hauls'" @click="openModal()">Add to folder</b-dropdown-item>
                <b-dropdown-item v-else @click="removeHaul()">Remove from folder</b-dropdown-item>
                <b-dropdown-item v-if="role =='trucking_company_admin'" @click="h_approved_click()">Approve Haul</b-dropdown-item>
                <b-dropdown-item v-if="role =='trucking_company_admin'" @click="h_deapproved_click()">Unapprove Haul</b-dropdown-item>
                <b-dropdown-item v-if="role =='trucking_company_admin' && (filters_save.flag_name == 'Unknow Load Location' || filters_save.flag_name == 'Price Anomaly' || filters_save.flag_name == 'Duplicated Truck Ticket' || filters_save.flag_name == 'Drive Time Anomaly')" @click="ignore_click(filters_save.flag_name)">Ignore</b-dropdown-item>
              </b-dropdown>
              <span class="align-middle ml-auto close-controls" @click="unselectAllHauls"> × </span>
            </div>
          </div>
        </b-col>
      </b-row> -->
    </div>

    <!-- Main table block -->
    <div class="card">
      <div class="card-body p-0">
        <!-- Shows when loading data-->
        <b-row v-if="loadingData">
          <b-col cols="12" sm="12" md="12" lg="12">
            <p class="text-center"> <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br> Loading data... </p>
          </b-col>
        </b-row>
        <div v-else class="table-responsive p-0 m-0">
          <b-table 
            class="animated fadeIn" 
            striped 
            bordered
            hover 
            show-empty 
            stacked="md" 
            :items="items" 
            :fields="fields" 
            :current-page="currentPage" 
            :per-page="perPage" 
            @filtered="onFiltered" 
            :filter="filter" 
            @row-clicked="rowClicked"
          >
          <!--  <template slot="HEAD_select_haul" slot-scope="data">
              <b-form-checkbox
                id="checkbox"
                @click.native.stop
                v-model="allSelected" 
                @change="toggleAllSelected"
              ></b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
             :filter="filter"  
                          @sort-changed="sortingChanged" 
            @filtered="onFiltered"
              @row-clicked="rowClicked"
            @refreshed="haulUpdated" 
            :sort-by.sync="filters_save.sortby" 
            :sort-desc.sync="filters_save.sortdesc"-->
            <!--<template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>  -->
          </b-table> 
          <!--<b-table @refreshed="haulUpdated" v-if="!loadingData && filters_save.flag_name == 'Volume > 60 m³' && FromDash!='Waittimes'" class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>
          <b-table @refreshed="haulUpdated" v-if="!loadingData && filters_save.flag_name == 'BS&W - 100%' && FromDash!='Waittimes'" class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>
          <b-table @refreshed="haulUpdated" v-if="!loadingData && filters_save.flag_name == 'BS&W < 0.5%' && FromDash!='Waittimes'" class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>
          <b-table @refreshed="haulUpdated" v-if="!loadingData && filters_save.flag_name == 'BS&W - Additional Fees Apply' && FromDash!='Waittimes'" class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>
          <b-table @refreshed="haulUpdated" v-if="!loadingData && filters_save.flag_name == 'Haul without Nom' && FromDash!='Waittimes' " class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>
          <b-table @refreshed="haulUpdated" v-if="!loadingData && FromDash=='Waittimes'" class="animated fadeIn" striped hover show-empty stacked="md" :items="v_items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked" >
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>
          <b-table @refreshed="haulUpdated" v-if="!loadingData && filters_save.flag_name == 'With Contracts' && FromDash!='Waittimes' " class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>

          <b-table v-if="!loadingData && filters_save.flag_name == 'Without Contracts' && FromDash!='Waittimes' " class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>

          <b-table v-if="!loadingData && filters_save.flag_name == 'Rerouted: Yes' && FromDash!='Waittimes' " class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>

          <b-table v-if="!loadingData && filters_save.flag_name == 'Rerouted: No' && FromDash!='Waittimes' " class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>
          <b-table @refreshed="haulUpdated" v-if="!loadingData && filters_save.flag_name == 'Haul Duplicated' && FromDash!='Waittimes' " class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>
          <b-table @refreshed="haulUpdated" v-if="!loadingData && filters_save.flag_name == 'Drive Time:Neg' && FromDash!='Waittimes'" class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table>
          <b-table @refreshed="haulUpdated" v-if="role =='trucking_company_admin' && !loadingData && (filters_save.flag_name == 'Unknow Load Location' || filters_save.flag_name =='Price Anomaly' || filters_save.flag_name == 'Duplicated Truck Ticket' || filters_save.flag_name =='Drive Time Anomaly') && FromDash!='Waittimes'" class="animated fadeIn" striped hover show-empty stacked="md" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="filters_save.sortby" :sort-desc.sync="filters_save.sortdesc" @sort-changed="sortingChanged" @filtered="onFiltered" @row-clicked="rowClicked">
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template  slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>
            <template slot="load_location" slot-scope="row">
              <span v-if="row.item.multiloads" @click.stop="row.toggleDetails" class="show-details-cell">
                Multi-Loads
              </span>
              <span v-else>
                {{row.item.load_location}}
              </span>
            </template>
            <template slot="row-details" slot-scope="row">
              <row-details :loads="row.item.loads"></row-details>
            </template>
          </b-table> -->
        </div>
        <!-- Info modal 
        <b-modal id="modalInfo" @hide="resetModal" :title="modalInfo.title" ok-only>
          <pre>{{ modalInfo.content }}</pre>
        </b-modal> -->
        <!-- Edit Modal
        <b-modal id="modalEdit" ref="mEdit" @hide="resetEditModal" :title="modalEdit.title" ok-only ok-title="Cancel" ok-variant="secundary">
          <b-row>
            <b-col cols="12">
              <b-input-group class="mb-3">
                <div class="input-group-prepend"><span class="input-group-text"><i class="icon-fire"></i></span></div>
                <input type="text" v-model="companyName" class="form-control" placeholder="Company name">
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-button variant="primary" @click="updateEC" class="px-4 pull-right">Update</b-button>
            </b-col>
          </b-row>
        </b-modal> -->
        <!-- User Interface controls -->
        <div class="table-controls">
          <b-row>
            <b-col lg="2" md="2" sm="12" class="my-1 pull-right">
              <div class="input-group mb-3">
                <div class="input-group-prepend"> </div>
                <b-select :options="pageOptions" v-model="perPage" />
              </div>
            </b-col>
            <b-col lg="10" md="10" sm="12" class="my-1">
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="mt-0 mb-3 pull-right" />
            </b-col>
          </b-row>
        </div>
        <!-- End User Interface controls-->
      </div>
    </div>
    <!-- New Energy Company Modal
    <b-modal class="newHaulModal" ref="newHaulModal" title="New Haul" v-model="newEC" hide-header-close no-close-on-backdrop no-close-on-esc>
      <b-row>
        <b-col cols="12">
          <b-form-group v-if="role !='trucking_company_admin'" :label-cols="4" horizontal label="Truking Company" label-for="truck_company">
            <b-form-select id="truck_company_id" v-model="newHaul.truck_company_id" :options="newHaul.truck_company_select" @input="selects_trucking_company()" />
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Driver" label-for="full_name">
            <b-form-select :disabled="newHaul.driver_select.length==0" id="user_id" v-model="newHaul.user_id" :options="newHaul.driver_select" @input="selects_driver()" />
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Energy Company" label-for="energy_company">
            <b-form-select :disabled="newHaul.energy_company_select.length==0" id="energy_companies_id" v-model="newHaul.energy_companies_id" :options="newHaul.energy_company_select" @input="selects_energy_company()" />
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Truck" label-for="truck">
            <b-form-select :disabled="newHaul.truck_select.length==0" id="truck_id" v-model="newHaul.truck_id" :options="newHaul.truck_select" />
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Load" label-for="load_location">
            <b-form-select :disabled="newHaul.load_location_select.length==0" id="load_location_id" v-model="newHaul.load_location_id" :options="newHaul.load_location_select" @input="selects_load_location()" />
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Fluid" label-for="fluid_type">
            <b-form-select :disabled="newHaul.fluid_type_select.length==0" id="fluid_type_id" v-model="newHaul.fluid_type_id" :options="newHaul.fluid_type_select" />
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Unload" label-for="unload_location">
            <b-form-select :disabled="newHaul.unload_location_select.length==0" id="unload_location_id" v-model="newHaul.unload_location_id" :options="newHaul.unload_location_select" />
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Water Cut Actual %" label-for="water_percentage_actual">
            <b-form-input id="water_percentage_actual" placeholder="0.00" v-model="newHaul.water_percentage_actual" type="text" @blur.native="inputBlur('water_percentage_actual')" @keydown.native="myOnlyNumber($event, 'water_percentage_actual')"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Volume Actual" label-for="volume_actual">
            <b-form-input id="volume_actual" placeholder="0.00" v-model="newHaul.volume_actual" @keydown.native="myOnlyNumber($event, 'volume_actual')" @blur.native="inputBlur('volume_actual')" type="text"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="# Ticket" label-for="ticket">
            <b-form-input id="ticket" v-model="newHaul.ticket" type="text"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Chain Up" label-for="chain_up">
            <b-form-select  id="chain_up" v-model="newHaul.chain_up"><option :value='false'>NO</option><option :value='true'>YES</option></b-form-select>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Start Date" label-for="haul_start_date">
            <b-form-input id="haul_start_datetime" v-model="newHaul.haul_start_datetime" type="date" ></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Start Time" label-for="haul_start_time">
            <b-form-input id="haul_start_time" placeholder="hh:mm" v-mask="'##:##'" @blur.native="timeBlur('haul_start_time')" v-model="newHaul.haul_start_time" type="text"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="End Date" label-for="haul_start_date">
            <b-form-input id="haul_end_datetime" v-model="newHaul.haul_end_datetime" type="date"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="End Time" label-for="haul_end_time">
            <b-form-input id="haul_end_time" placeholder="hh:mm" v-mask="'##:##'" @blur.native="timeBlur('haul_end_time')" v-model="newHaul.haul_end_time" type="text"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Comments Start" label-for="comments_start">
            <b-form-input id="comments_start" v-model="newHaul.comments_start" type="text"></b-form-input>
          </b-form-group>

          <b-form-group v-for="(wait_time, index) in newHaul.wait_times" :key="wait_time.type_id" :label-cols="4" horizontal :label="waitTimeLabel(wait_time)" :label-for="waitTimeLabel(wait_time)">
            <b-form-input placeholder="hh:mm" v-mask="'##:##'" v-model="wait_time.time" type="text"></b-form-input>
            <b-form-input placeholder="Comments" v-model="wait_time.comments" type="text"></b-form-input>
            <b-btn v-if="wait_time.type_id == 5" size="md" variant="secondary" @click="removeTimeBlur(index)" class="wait-time-remove-button">X</b-btn>
          </b-form-group>

          <b-btn size="md" variant="primary" @click="addWaitTime" class="float-right">Add another Wait Time</b-btn>

        </b-col>
      </b-row>
      <div slot="modal-footer" class="w-100">
        <b-btn size="md" variant="secondary" @click="hideNewHaulModal" class="float-left">Cancel</b-btn>
        <b-btn :disabled="savebtn" size="md" variant="primary" @click="saveHaul" class="float-right">Save</b-btn>
      </div>
    </b-modal> -->
    <!-- End New Energy Company Modal-->

    <!-- Configure Columns to Display -->
    <b-modal title="Columns to Display" v-model="configTable" ok-variant="primary">

      <b-container class="bv-example-row">
        <b-row>
          <b-col md="6">
            <b-form-checkbox-group stacked id="basicCheckboxes" name="Checkboxes" :plain="true" :checked="selectedItems">
              <b-form-checkbox :disabled="shouldBeDisabled('haul_id')" value="haul_id" @change="actionField('haul_id', 'ID', 1)">Id</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('full_name')" value="full_name" @change="actionField('full_name', 'Driver', 4)">Driver</b-form-checkbox>
              <b-form-checkbox v-if="role =='super_admin' || role =='trucking_company_admin' || role =='operations_manager' || role =='trucking_operational_manager'" :disabled="shouldBeDisabled('energy_company')" value="energy_company" @change="actionField('energy_company', 'Energy Company', 2)">Energy Company</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('load_location')" value="load_location" @change="actionField('load_location', 'Load', 5)">Load</b-form-checkbox>

              <b-form-checkbox :disabled="shouldBeDisabled('unload_location')" value="unload_location" @change="actionField('unload_location', 'Unload', 6)">Unload</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('truck')" value="truck" @change="actionField('truck','Truck',7)">Truck</b-form-checkbox>
              <!-- <b-form-checkbox :disabled="shouldBeDisabled('ticket')" value="ticket" @change="actionField('ticket', 'Ticket #',8)">Ticket #</b-form-checkbox> -->
              <b-form-checkbox :disabled="shouldBeDisabled('volume_actual')" value="volume_actual" @change="actionField('volume_actual','Deliveries',9)">Deliveries</b-form-checkbox>

              <b-form-checkbox :disabled="shouldBeDisabled('oil_actual')" value="oil_actual" @change="actionField('oil_actual','Oil',10)">Oil</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('water_actual')" value="water_actual" @change="actionField('water_actual', 'Water',11)">Water</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('bsw')" value="bsw" @change="actionField('bsw', 'BS&W', 12)">BS&W</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('haul_start_date')" value="haul_start_date" @change="actionField('haul_start_date', 'Start Date', 13)">Start Date</b-form-checkbox>

              <b-form-checkbox :disabled="shouldBeDisabled('haul_end_date')" value="haul_end_date" @change="actionField('haul_end_date', 'End Date', 14)">End Date</b-form-checkbox>
              <!-- <b-form-checkbox :disabled="shouldBeDisabled('duration')" value="duration" @change="actionField('duration', 'Duration',9)">Duration</b-form-checkbox> -->
              <!-- <b-form-checkbox :disabled="shouldBeDisabled('rate')" value="rate" @change="actionField('rate','Rate', 10)">Rate</b-form-checkbox> -->
              <!-- <b-form-checkbox :disabled="shouldBeDisabled('stb')" value="stb" @change="actionField('stb', 'STB', 11)">STB</b-form-checkbox> -->

            </b-form-checkbox-group>
          </b-col>
          <b-col md="6">
            <b-form-checkbox-group stacked id="basicCheckboxes" name="Checkboxes" :plain="true" :checked="selectedItems">

              <!-- <b-form-checkbox :disabled="shouldBeDisabled('stb_rate')" value="stb_rate" @change="actionField('stb_rate','STB Rate', 12)">STB Rate</b-form-checkbox> -->
              <!-- <b-form-checkbox :disabled="shouldBeDisabled('unit_cost')" value="unit_cost" @change="actionField('unit_cost','Unit Cost',13)">Unit Cost</b-form-checkbox> -->
              <b-form-checkbox :disabled="shouldBeDisabled('fluid_type')" value="fluid_type" @change="actionField('fluid_type','Fluid Type', 15)">Fluid Type</b-form-checkbox>
              <!-- <b-form-checkbox :disabled="shouldBeDisabled('total_distance')" value="total_distance" @change="actionField('total_distance','Distance', 15)">Distance</b-form-checkbox> -->

             <!-- <b-form-checkbox :disabled="shouldBeDisabled('total')" value="total" @change="actionField('total','Total', 16)">Total</b-form-checkbox> -->
              <b-form-checkbox :disabled="shouldBeDisabled('trucking_company')" value="trucking_company" @change="actionField('trucking_company','Trucking Company', 3)">Trucking Company</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('water_percentage_actual')" value="water_percentage_actual" @change="actionField('water_percentage_actual','Water Cut Actual', 16)">Water Cut Actual</b-form-checkbox>
               <!--<b-form-checkbox :disabled="shouldBeDisabled('water_cut_estimate')" value="water_cut_estimate" @change="actionField('water_cut_estimate','Water Cut Estimate', 19)">Water Cut Estimate</b-form-checkbox> -->

              <b-form-checkbox :disabled="shouldBeDisabled('haul_start_time')" value="haul_start_time" @change="actionField('haul_start_time','Start Time', 17)">Start Time</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('haul_end_time')" value="haul_end_time" @change="actionField('haul_end_time','End Time', 18)">End Time</b-form-checkbox>
              <!-- <b-form-checkbox :disabled="shouldBeDisabled('driving_time')" value="driving_time" @change="actionField('driving_time','Driving Time', 22)">Driving Time</b-form-checkbox> -->

              <b-form-checkbox :disabled="shouldBeDisabled('avg_speed')" value="avg_speed" @change="actionField('avg_speed','Speed Avg', 19)">Speed Avg</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('cost_regular')" value="cost_regular" @change="actionField('cost_regular','Regular Cost', 20)">Regular Cost</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('cost_stb')" value="cost_stb" @change="actionField('cost_stb','STB Cost', 21)">STB Cost</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('total_cost')" value="total_cost" @change="actionField('total_cost','Total Cost', 22)">Total Cost</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('flags')" value="flags" @change="actionField('flags','Flags', 23)">Flags</b-form-checkbox>

            </b-form-checkbox-group>
          </b-col>
        </b-row>
      </b-container>
      <!-- </b-form-checkbox-group> -->

      <div slot="modal-footer" class="w-100">
        <b-btn size="md" class="float-left" variant="secondary" @click="configTable=false">
          Cancel
        </b-btn>

        <b-btn size="md" class="float-right" variant="primary" @click="saveSelectedColumns()">
          Save
        </b-btn>
      </div>

    </b-modal>

   <!--  <b-modal title="Add to Folders" v-model="modalFolders" ok-variant="primary" hide-header-close no-close-on-backdrop no-close-on-esc>

      <b-container class="bv-example-row">
        <b-row>
          <b-col md="12">
            <b-form-group  :label-cols="2" id="L4"  label-for="folderID" horizontal>
              <b-form-radio-group class="custom-checkboxes" :options="folderOptions" name="Checkboxes" plain v-model="selected"></b-form-radio-group>
              </b-form-group>
          </b-col>
        </b-row>
      </b-container> 

      <div slot="modal-footer" class="w-100">
        <b-btn size="md" class="float-left" variant="secondary" @click="modalFolders=false">
          Cancel
        </b-btn>

        <b-btn size="md" class="float-right" variant="primary" @click="addHaulsFolder()">
          Save
        </b-btn>
      </div>

    </b-modal> -->
    <!-- Configure Columns to Display-->

  </div>
</template>

<script>
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2'
  import haul_service from './haul_service'
  import moment from 'moment';
  import users_service from '../users/users_service'
  import rowDetails from './rowDetails'

  Vue.use(VueSweetalert2)
  
  const items = []
  export default {
    name: 'DuplicatedHauls',
        components:{
      'row-details' : rowDetails
    },
    created: function() {
      this.getAll()
    },
    data() {
      return {
        allSelected                 : false,
        tableValues                 : [],
        status                      :'unchecked',
        haul_ids                    : [],
        haul_iidds                  : [],
        haul_iiddss                 : [],
        selected                    : '',
        row: 0,
        loadingData: true,
        companyName: '',
        companyId: null,
        configTable: false,

        items: items,
        totalRows: items.length,
        v_items:null,
        fieldsSelected: 8,
        maxFieldsSelected: 24,
        tempFields: [],
        fields: [
        {
          key: 'haul_id',
          label: 'ID',
          sortable: false
        },  
        {
          key: 'ticket',
          label: 'Ticket #',
          sortable: false
        },
        {
          key: 'load_location',
          label: 'Load',
        }, {
          key: 'unload_location',
          label: 'Unload',
          sortable: false,
        }, {
          key: 'volume_actual',
          label: 'Deliveries',
          sortable: false,
          formatter: (value) => { if (this.bbll==true){
                                    value = Number(value*6.289814).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' bbl'
                                  } else {
                                    value = Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' m³'
                                  }; return value }
        }, {
          key: 'oil_actual',
          label: 'Oil',
          sortable: false,
          formatter: (value) => { if (this.bbll==true){
                                    value = Number(value*6.289814).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' bbl'
                                  } else {
                                    value = Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' m³'
                                  }; return value }
          // formatter: (value) => { return Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+this.unit }
        }, {
          key: 'water_actual',
          label: 'Water',
          sortable: false,
          formatter: (value) => { if (this.bbll==true){
                                    value = Number(value*6.289814).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' bbl'
                                  } else {
                                    value = Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' m³'
                                  }; return value }
          
          }, 
          {
          key: 'bsw',
          label: 'BS&W (%)',
          sortable: false,
          }, 
          {
          key: 'haul_start_date',
          label: 'Start Date',
          sortable: false,
          formatter:(value) => { return moment(value).format("MMM DD, YYYY") }
        }],
        currentPage               : 1,
        perPage                   : 25,

        pageOptions               : [25, 50, 100],
        filter                    : null,
        modalInfo                 : {
          title: '',
          content: ''
        },
        modalEdit                 : {
          title: ''
        },
        selectedItems             : [
          'haul_id',
          'ticket',
          'load_location',
          'unload_location',
          'volume_actual',
          'oil_actual',
          'water_actual',
          'bsw',
          'haul_start_date',
        ],
				role                      :'',
				savebtn                   :true,
				energy_company_id         :null,
        unit                      :'',
        fromHaul                  :0,
        bbll                      :false,
        myToggle                  :false,
        filter_by:{"initial_date": moment().startOf('week').format('YYYY-MM-DD'), "end_date": moment().endOf('week').format('YYYY-MM-DD'), "truck_id": "","trucking_company_id":"", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "",
        "column":[
          'haul_id',
          'truck_ticket',
          'load_location',
          'unload_location',
          'volume_actual',
          'oil_actual',
          'water_actual',
          'bsw',
          'haul_start_date',
        ]},
        energy_companies_filter     : '',
        //folders                     : '',
        load_locations_filter       : '',
        unload_locations_filter     : '',
        drivers_filter              : '',
        trucks_filter               :'',
        trucking_companies_filter   :'',
        //fluid_types_filter          :'',
        filters_save              : {
          //folder_id               : 0,
          //folder                  : 'All Folders',
          energy_companies_id     : 0,
          energy_company_name     : 'All Energy Companies',
          users_id                : 0,
          driver_name             : 'All Drivers',
          truck_id                : 0,
          truck_name              : 'All Trucks',
          trucking_company_id     : 0,
          trucking_company_name   : 'All Trucking Companies',
          load_location_id        : 0,
          load_name               : 'All Loads',
          //fluid_type_id           : 0,
          //fluid_type_name         : 'All Fluid Types',
          unload_location_id      : 0,
          unload_name             : 'All Unloads',
          initial_date            : '',
          end_date                : '',
          //flag_name               : 'All Flags',
          //sortby                  : 'haul_id',
          //sortdesc                : false
        },
      }
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return {
              text: f.label,
              value: f.key
            }
          })

      }
    },
    methods: {
      selectAllHauls() {
        if (!this.allSelected) {
          this.toggleAllSelected();
        }
      },
      unselectAllHauls() {
        if (this.haul_ids.length>0 ) {
          //if (!this.h_approved) {
              this.haul_ids = []
          //} else {
              let tmp1 = this.tableValues.map(item => {
                   return item.haul_id})
              let tmp = this.haul_ids
              let tmp2 = this.array_diff(tmp, tmp1) 
              this.haul_ids = tmp2
          //}
        }
      },
      toggleAllSelected() {
        this.allSelected = !this.allSelected
        if (this.allSelected) {
          //if (!this.h_approved) {
           // this.haul_ids = []
            //this.haul_ids = this.tableValues.map(item => {
             //      return item.haul_id})
         // } else {
            let tmp = this.tableValues.map(item => {
                   return item.haul_id})
            let tmp1 = this.haul_ids
            tmp1.push.apply(tmp1,tmp)
            this.haul_ids = [...new Set(tmp1)]
          //}
        }
        else {
          //if (!this.h_approved) {
            //  this.haul_ids = []
          //} else {
              let tmp1 = this.tableValues.map(item => {
                   return item.haul_id})
              let tmp = this.haul_ids
              let tmp2 = this.array_diff(tmp, tmp1) 
              this.haul_ids = tmp2
          //}
        }
      },
      array_diff(tmp, tmp1) {
	      return tmp.filter(elemento => tmp1.indexOf(elemento) == -1)
      }, 

      checkedField(row) {
        if (this.haul_ids.includes(row.item.haul_id) ) {
          let index = this.haul_ids.indexOf(row.item.haul_id);
           if (index > -1) {
             this.haul_ids.splice(index, 1);
           }
        }else{
          this.haul_ids.push(row.item.haul_id)

        }
      },
      activate_custom_backdrop() {
        this.$root.$el.classList.add("custom_backdrop_behavior");
      },
      deactivate_custom_backdrop() {
        this.$root.$el.classList.remove("custom_backdrop_behavior");
      },
      openSelectColumns() {
        this.tempFields = [...this.fields]
        this.configTable = true
      },
      saveSelectedColumns() {
        this.fields = [...this.tempFields]
        this.configTable = false
      },
      shouldBeDisabled(option) {
        return (this.fieldsSelected >= this.maxFieldsSelected) && this.tempFields.map(o => o.key).indexOf(option) == -1
      },
      actionField(option, label, position) {
        var fieldsLength = this.tempFields.length
        var fieldIsActive = false
        for (var i = 0; i <= fieldsLength; i++) {
          fieldIsActive = true
          try {
            if (this.tempFields[i].key === option || this.tempFields[i] === option) {
              this.tempFields.splice(i, 1)
              fieldIsActive = false
              break
            }
          } catch (err) {

            if (option=='haul_start_date' || option=='haul_end_date') {
              option = {
                key: option,
                label: label,
                sortable: true,
                formatter: (value) => { return moment(value).format("MMM DD, YYYY") }
              }
            } else if (option=='oil_actual' || option=='volume_actual' || option=='water_actual') {
                      option = {
                        key: option,
                        label: label,
                        sortable: true,
                        formatter: (value) =>  { if (this.bbll==true){
                                    value = Number(value*6.289814).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' bbl'
                                  } else {
                                    value = Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' m³'
                                  }; return value }
                      }
            } else {
                option = {
                  key: option,
                  label: label,
                  sortable: true
                }
            }
            this.tempFields.splice(position, 0, option)
          }
        }
        this.fieldsSelected = this.tempFields.length
      },
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      getAll() {
        this.items = []
        //this.v_items = []
        haul_service.get_duplicated_hauls(this.filter_by)
          .then(data => {
            if (data.status == 'success') {
              this.items      = data.hauls.filter(o => o.status_id == (this.trash ? 2 : 1))
              this.itemsAll   = this.items 
              //console.log(this.items)
              //this.role= data.role
              this.getAll1()
            }
            else {
              this.$swal(data.status, data.message, data.status)
              this.loadingData = false
              return
            }
            this.loadingData = false
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
            this.loadingData = false
          })
      },
      getAll1() {

        haul_service.getAll1()
          .then(data => {
            if (data.status == 'success') {
              
              this.energy_companies_filter  = data.energy_companies_filter
              //this.folders                  = data.folders
              this.drivers_filter           = data.drivers_filter
              this.load_locations_filter    = data.load_locations_filter
              this.unload_locations_filter  = data.unload_locations_filter
              this.trucks_filter            = data.trucks_filter
              //this.truck_types_filter       = data.truck_types_filter
              this.trucking_companies_filter = data.trucking_companies_filter
              //this.fluid_types_filter       = data.fluid_types_filter 

              this.bbll       = data.bbl
  						this.role       = data.role

            }
            else {

              this.$swal(data.status, data.message, data.status)
              this.loadingData = false
              return
            }
            this.loadingData = false
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
            this.loadingData = false
          })
      },
      reformat(value) {
        if (value.indexOf('%')!= -1) {
            return Number(parseFloat(value.replace(" %", "")).toFixed(2)).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+" %"
        } else if (value.indexOf('km')!= -1) {
            return Number(parseFloat(value.replace(" km", "")).toFixed(2)).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+" km"
        } else {
            return Number(parseFloat(value).toFixed(2)).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})
        }
      },
      ecFilter(ec_filter,id) {
        this.filter_by['energy_companies_id'] = id

        if (id==0) {
          this.filter_by['energy_companies_id'] = ''
        }
        this.filters_save.energy_company_name =  ec_filter
        this.filters_save.energy_companies_id = id
        this.getAll()
        //this.saveFilters()
        this.loadingData = true

      },
      dFilter(d_filter,id) {
        this.filter_by['users_id'] = id
        if (id==0) {
          this.filter_by['users_id'] = ''
        }
        this.filters_save.driver_name =  d_filter
        this.filters_save.users_id = id
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      tcFilter(tc_filter,id) {
        this.filter_by['trucking_company_id'] = id
        if (id==0) {
          this.filter_by['trucking_company_id'] = ''
        }
        this.filters_save.trucking_company_name =  tc_filter
        this.filters_save.trucking_company_id = id
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      lFilter(l_filter,id) {
        this.filter_by['load_location_id'] = id
        if (id==0) {
          this.filter_by['load_location_id'] = ''
        }
        this.filters_save.load_name =  l_filter
        this.filters_save.load_location_id = id
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      uFilter(u_filter,id) {
        this.filter_by['unload_location_id'] = id
        if (id==0) {
          this.filter_by['unload_location_id'] = ''
        }
        this.filters_save.unload_name =  u_filter
        this.filters_save.unload_location_id = id
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      iFilter(a) {
        if (this.filter_by['end_date']=='' || !this.filter_by['end_date']) {
          this.filter_by['end_date'] = ''
          this.filters_save.end_date = ''
        }
        this.filter_by.initial_date = a
        this.filters_save.initial_date = this.filter_by.initial_date
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      eFilter(a) {
        if (this.filter_by['initial_date'] =='' || !this.filter_by['initial_date']) {
          this.filter_by['initial_date'] = ''
          this.filters_save.initial_date = ''
        }
        this.filter_by.end_date = a
        this.filters_save.end_date = this.filter_by.end_date
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      tFilter(t_filter,id) {
        this.filter_by['truck_id'] = id
        if (id==0) {
          this.filter_by['truck_id'] = ''
        }
        this.filters_save.truck_name =  t_filter
        this.filters_save.truck_id = id
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      clearFilters() {
        this.filter_by = {"initial_date": moment().startOf('week').format('YYYY-MM-DD'), 
        "end_date": moment().endOf('week').format('YYYY-MM-DD'), 
        "truck_id": "",
        "trucking_company_id":"", 
        "users_id": "", 
        "unload_location_id": "", 
        "energy_companies_id": "", 
        "load_location_id": "", 
        "column":[
          'haul_id',
          'truck_ticket',
          'load_location',
          'unload_location',
          'volume_actual',
          'oil_actual',
          'water_actual',
          'bsw',
          'haul_start_date',    
        ]}
        this.filters_save = {
          energy_companies_id   : 0,
          energy_company_name   : 'All Energy Companies',
          users_id              : 0,
          driver_name           : 'All Drivers',
          trucking_company_id   : 0,
          truck_id              : 0,
          truck_name            : 'All Trucks',
          trucking_company_name : 'All Trucking Companies',
          load_location_id      : 0,
          load_name             : 'All Loads',
          unload_location_id    : 0,
          unload_name           : 'All Unloads',
          initial_date          : '', // moment().startOf('month').format('YYYY-MM-DD'),
          end_date              : '', //moment().endOf('month').format('YYYY-MM-DD'),
          flag_name             : 'All Flags',
          //sortby                : 'truck_ticket',
          //sortdesc              : false
        }
        //this.FromDash='NoWaittimes'
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      rowClicked(row, index, e) {
        e.preventDefault()
        localStorage.haulPage = this.currentPage;
        if(!this.trash) {
          //this.$router.push('/haul/'+row.haul_id+'/')
          this.selected_haul_detail = row.haul_id
          this.$root.$emit('openPopup', row.haul_id);
        } else {
          this.restoreHaul(row.haul_id)
        }
      },
  }
}
</script>

<style lang="scss" scoped>
  .show-details-cell{
    font-weight: 500;
    cursor: pointer;
  }
  .table-controls{
    padding: 14px 16px 0 16px;
  }
  /deep/ .table{
    margin: 0;
    td{
      white-space: nowrap;
      vertical-align: middle;
    }
    th{
      white-space: nowrap;
      vertical-align: middle;
    }
    td> div{
      line-height: 1;
    }
    .b-table-details> td {
      background-color: #FFFDF0;
    }
    .b-table-details h6{
      padding: 0;
      margin: 0;
      font-size: 0.8rem;
      line-height: 16px;
      margin-bottom: 8px;
      color: #676973;
    }
    .b-table-details p{
      font-size: 16px;
      color: #3A3E4D;
      padding: 0;
      margin: 0;
      line-height: 18px;
      margin-bottom: 16px;
    }
    .details-container{
      position: relative;
      white-space: normal; 
      display: flex; 
      flex-direction: row;
      flex-wrap: nowrap; 
      justify-content: flex-start;
      .item{
        padding-left: 10px;
        padding-right: 10px;
      }
      .item.location{
        width: 180px;
      }
      .item.ticket{
        width: 130px;
      }
      .item.date{
        width: 180px;
      }
      .item.volume{
        min-width: 100px;
      }
      &::after{
        content: '';
        position: absolute;
        top: 17px;
        left: 0;
        width: 20px;
        height: 100%;
        border-top: 1px solid #bcbcbc;
      }
      &::before{
        content: '';
        position: absolute;
        top: 17px;
        left: 0;
        width: 2px;
        height: 100%;
        border-left: 1px solid #bcbcbc;
      }
    }
    .details-container:last-child::before{
      display: none;
    }
  }
  /deep/ .btn-secondary{
    background: #ffffff;
  }
  /deep/ .custom-control {
    margin: 0;
    padding-left: 1rem;
  }
  /deep/ .select_column{width: 2%}
  /deep/ .bulk-action-controls{
    .dropdown{
      display: block;
      width: 100%;
    }
    .dropdown-toggle{
      display: block;
      width: 100%;
      text-align: left;
    }
    .dropdown-toggle::after {
      position: absolute;
      right: 15px;
      top: 50%;
      margin-top: -2px;
    }
    .close-controls{
      font-size: 18px; 
      font-weight: bold;
      height: 35px; 
      line-height: 14px;
      cursor: pointer;
      padding: 8px;
    }
    .btn-secondary{
      border-color: #cacaca;
    }
    .btn-select{
      height: 35px;
      margin-bottom: auto;
      margin-top: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/hauls/duplicated_hauls.vue